import classnames from 'classnames'
import { ReactNode } from 'react'
import { KeyValue } from '../../lib/keyboard'
import { CharStatus } from '../../lib/statuses'

type Props = {
  children?: ReactNode
  value: KeyValue
  width?: number
  status?: CharStatus
  onClick: (value: KeyValue) => void
}

export const Key = ({
  children,
  status,
  width = 40,
  value,
  onClick,
}: Props) => {
  const classes = classnames(
    'flex items-center justify-center rounded mx-0.5 max-[350px]:mx-0.5 max-[320px]:mx-0 text-base max-[375px]:text-sm max-[350px]:text-sm max-[320px]:text-xs font-bold cursor-pointer select-none dark:text-white',
    {
      'bg-slate-200 dark:bg-slate-500 hover:bg-slate-300 active:bg-slate-400':
        !status,
      'bg-slate-500 dark:bg-slate-700 text-white': status === 'absent',
      'bg-green-700 hover:bg-green-700 active:bg-green-700 text-white':
        status === 'correct',
      'bg-yellow-400 hover:bg-yellow-500 active:bg-yellow-600 dark:bg-yellow-400 text-white':
        status === 'present',
      'bg-slate-200 hover:bg-slate-300 dark:hover:bg-slate-800 active:bg-slate-100 dark:bg-slate-500 text-black dark:text-white':
        status === 'red',
    }
  )

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick(value)
    event.currentTarget.blur()
  }

  return (
    <button
      className={`${classes} h-[58px] max-[375px]:h-[46px] max-[350px]:h-[44px] max-[320px]:h-[40px] ${
        width > 40
          ? 'w-[65.4px] max-[375px]:w-[52px] max-[350px]:w-[48px] max-[320px]:w-[56px]'
          : 'w-[40px] max-[375px]:max-w-[32px] max-[375px]:min-w-[28px] max-[350px]:max-w-[28px] max-[350px]:min-w-[26px] max-[320px]:max-w-[26px] max-[320px]:min-w-[24px]'
      }`}
      onClick={handleClick}
    >
      {children || value}
    </button>
  )
}
